import { render, staticRenderFns } from "./NeedsActivities.vue?vue&type=template&id=260ecd8a&scoped=true&"
import script from "./NeedsActivities.vue?vue&type=script&setup=true&lang=js&"
export * from "./NeedsActivities.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260ecd8a",
  null
  
)

export default component.exports